[
    { "value":"Angioectasia"},
    { "value":"Angiodysplasia"},
    { "value":"Achalasia"},
    { "value":"Bleeding of unknown origin"},
    { "value":"Barretts esophagus"},
    { "value":"Celiac disease Susp"},
    { "value":"Colitis - ischemic Susp"},
    { "value":"Colitis"},
    { "value":"Colitis pseudomembranous"},
    { "value":"Colonic polyp s"},
    { "value":"Colonic mass"},
    { "value":"Colorectal superficial neoplasm"},
    { "value":"Crohn`s disease Susp"},
    { "value":"Crohn`s disease"},
    { "value":"Colonic Polyp - Juvenile"},
    { "value":"Cameron's Ulcer"},
    { "value":"Dieulafoy lesion"},
    { "value":"Diverticulitis"},
    { "value":"Diverticulosis"},
    { "value":"Diverticula"},
    { "value":"Duodenal benign tumor"},
    { "value":"Duodenal bulb deformity"},
    { "value":"Duodenal cancer Susp"},
    { "value":"Duodenal diverticulum"},
    { "value":"Duodenal fistula"},
    { "value":"Duodenal polyp"},
    { "value":"Duodenal postoperative appearance"},
    { "value":"Duodenal submucosal tumor"},
    { "value":"Duodenal ulcer"},
    { "value":"Duodenal ulcer with bleeding"},
    { "value":"Duodenal ulcer with NBVV"},
    { "value":"Duodenopathy erosive"},
    { "value":"Duodenopathy hemorrhagic"},
    { "value":"Duodenopathy hyperemic"},
    { "value":"Duodenitis"},
    { "value":"Erosions"},
    { "value":"Eosinophilic esophagitis"},
    { "value":"Esophagitis other"},
    { "value":"Esophagitis reflux"},
    { "value":"Esophageal benign tumor"},
    { "value":"Esophageal caustic injury"},
    { "value":"Esophageal cancer Susp"},
    { "value":"Esophageal candidiasis"},
    { "value":"Esophageal diverticulum"},
    { "value":"Esophageal fistula"},
    { "value":"Esophageal foreign body"},
    { "value":"Esophageal polyp"},
    { "value":"Esophageal postoperative apperance"},
    { "value":"Esophageal stricture"},
    { "value":"Esophageal submucosal tumor"},
    { "value":"Esophageal varices"},
    { "value":"Esophagitis"},
    { "value":"External hemorrhoids"},
    { "value":"Extrinsic compression"},
    { "value":"Fistula"},
    { "value":"Foreign body"},
    { "value":"Food in stomach"},
    { "value":"Gastritis"},
    { "value":"Gastric tumor"},
    { "value":"Gastric cancer Susp"},
    { "value":"Gastric diverticulum"},
    { "value":"Gastric fistula"},
    { "value":"Gastric foreign body"},
    { "value":"Gastric caustic injury"},
    { "value":"Gastric lymphoma Susp"},
    { "value":"Gastric polyp s"},
    { "value":"Gastric postoperative appearance"},
    { "value":"Gastric retention"},
    { "value":"Gastric submucosal tumor"},
    { "value":"Gastric ulcer"},
    { "value":"Gastric ulcer with bleeding"},
    { "value":"Gastric ulcer with NBVV"},
    { "value":"Gastric ulcer anastomotic"},
    { "value":"Gastric varices"},
    { "value":"Gastric mass"},
    { "value":"Gastropathy erosive"},
    { "value":"Gastropathy hemorrhagic"},
    { "value":"Gastropathy hyperemic"},
    { "value":"Gastropathy nodular"},
    { "value":"Gastropathy hypertrophic"},
    { "value":"Gastropathy NSAID related"},
    { "value":"Gastropathy portal hypertensive"},
    { "value":"Hiatus hernia"},
    { "value":"Hemorrhoids"},
    { "value":"Helicobacter Rapid Test"},
    { "value":"Hirschsprung Disease R/O"},
    { "value":"rapid urease test-"},
    { "value":"Lipoma"},
    { "value":"Lymphoma Susp"},
    { "value":"Lymphangioectasia"},
    { "value":"Mallory Weiss tear"},
    { "value":"Melanosis coli"},
    { "value":"Normal gastroscopy"},
    { "value":"Normal colonoscopy"},
    { "value":"Normal Colonic Study"},
    { "value":"Normal ileoscopy"},
    { "value":"Ileitis"},
    { "value":"Incomplete examination"},
    { "value":"Intestinal anastomosis"},
    { "value":"Internal hemorrhoids"},
    { "value":"Ischemic colitis"},
    { "value":"Non diagnostic examination"},
    { "value":"Pancreatic rest"},
    { "value":"Paraesophageal hernia"},
    { "value":"Parasites"},
    { "value":"Peutz Jaeger polyposis"},
    { "value":"Pneumatosis coli"},
    { "value":"Polyposis syndrome Susp"},
    { "value":"Postoperative appearance"},
    { "value":"Pseudomembranous colitis"},
    { "value":"Pyloric stenosis"},
    { "value":"Proctitis"},
    { "value":"Rectal ulcer"},
    { "value":"Solitary ulcer"},
    { "value":"Stricture benign"},
    { "value":"Stricture inflammatory"},
    { "value":"Stricture malignant"},
    { "value":"Scar"},
    { "value":"Stricture postoperative"},
    { "value":"Schatzki ring"},
    { "value":"Submucosal mass"},
    { "value":"Ulcerative colitis Susp"},
    { "value":"Ulcerative colitis"},
    { "value":"Ulcer"},
    { "value":"Unpreparated patient"},
    { "value":"Rectal polyp s"},
    { "value":"Rectal mass"},
    { "value":"Suboptimal preparation"},
    { "value":"Polypectomy"},
    { "value":"Positive Helicobacter Rapid Test"}

    ]